import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeNumber'
})
export class SafeNumberPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(value: any, args?: any): any {
    return this.isNumeric(value) ? this.decimalPipe.transform(value, args) : value;
  }

  // https://github.com/ReactiveX/rxjs/blob/6.x/src/internal/util/isNumeric.ts
  isNumeric(val: any): val is number | string {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !this.isArray(val) && (val - parseFloat(val) + 1) >= 0;
  }

  // https://github.com/ReactiveX/rxjs/blob/6.x/src/internal/util/isArray.ts
  isArray = (() => Array.isArray || (<T>(x: any): x is T[] => x && typeof x.length === 'number'))();
}
